import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './translations';

const savedLang = localStorage.getItem('language');

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: savedLang || 'de',
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;